export const SESSION_PATHS = {
  ROOT: "/user",
  LOGIN_WITH_PASSWORD: "/user/login",
  LOGIN_WITH_SSO: "/user/login-sso",
  FORGOT_PASSWORD: "/user/forgot-password",
} as const;
